export const createAsyncState = (actionTypes) => ({
  loading: actionTypes.reduce((acc, type) => ({ ...acc, [type]: false }), {}),
  error: actionTypes.reduce((acc, type) => ({ ...acc, [type]: null }), {})
});

export const createAsyncMutations = (setLoadingType, setErrorType) => ({
  [setLoadingType](state, { type, value }) {
    state.loading[type] = value;
  },
  [setErrorType](state, { type, value }) {
    state.error[type] = value;
  }
});

export const handleAsyncAction = async ({
  commit,
  actionType,
  errorMessage,
  asyncOperation,
  setLoading,
  setError
}) => {
  commit(setLoading, {
    type: actionType,
    value: true
  });

  try {
    commit(setError, {
      type: actionType,
      value: null
    });
    const result = await asyncOperation();
    return result;
  } catch (err) {
    let msg = errorMessage;
    if (err.response?.status < 500) {
      msg = err.response?.data?.message;
    }
    if (err.uiMessage) {
      msg = err.uiMessage;
    }
    commit(setError, {
      type: actionType,
      value: msg
    });
    console.error(err);
    throw err;
  } finally {
    commit(setLoading, {
      type: actionType,
      value: false
    });
  }
};
